/**
 * Backend API base URL.
 * - Set REACT_APP_API_URL in .env (dev) or in CI (e.g. GitHub secret) for production.
 * - Development: defaults to http://localhost:5000
 * - Production: defaults to '' (same-origin) if unset; set REACT_APP_API_URL to your
 *   deployed backend (e.g. Cloud Run, Render) to fix 404 / "AI not available".
 */
const u = process.env.REACT_APP_API_URL;
export const API_BASE =
  typeof u === 'string' && u.trim() !== ''
    ? u.replace(/\/$/, '')
    : process.env.NODE_ENV === 'production'
    ? ''
    : 'http://localhost:5000';

export default API_BASE;
